// import { ChevronLeftIcon, ChevronRightIcon, ZoomInIcon, ZoomOutIcon } from '@radix-ui/react-icons';
import React, { useMemo, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// @ts-ignore
import 'react-pdf/dist/Page/TextLayer.css';
// @ts-ignore
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { ocrPalette } from '../pages/generic-ocr/ocrPalette';
import { PreviewIconButton } from '../pages/generic-ocr/DocumentPreview';

// CRA/webpack does not resolve import.meta.url for the worker in production builds.
// Serve the worker from /public. Use .js (not .mjs) so SPA hosts like Amplify
// do not rewrite the request to index.html (their rules allow .js, not .mjs).
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

// const PDFJS_WASM_URL = `${import.meta.env.BASE_URL}pdfjs-wasm/`;

const PDFViewer = ({ src }: { src: string }) => {
    const [numPages, setNumPages] = useState(0);
    const [scale, setScale] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
        setNumPages(numPages);
    }

    const pages = useMemo(() => {
        return Array.from({ length: numPages }, (_, index) => index + 1);
    }, [numPages]);

    // const documentOptions = useMemo(
    //     () => ({ wasmUrl: PDFJS_WASM_URL }),
    //     [],
    // );

    return (
        <Paper
            elevation={0}
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                bgcolor: ocrPalette.surface,
                border: `1px solid ${ocrPalette.border}`,
                borderRadius: "10px",
                p: 1.25,
                alignSelf: "start",
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: ocrPalette.text }}>
                    Source document
                </Typography>
                <Stack direction="row" spacing={0.5}>
                    <PreviewIconButton disabled={scale < 1} ariaLabel="Zoom out" onClick={() => setScale(prev => prev - 0.5)}>
                        <RemoveIcon sx={{ fontSize: 16 }} />
                    </PreviewIconButton>
                    <PreviewIconButton disabled={scale >= 3} ariaLabel="Zoom in" onClick={() => setScale(prev => prev + 0.5)}>
                        <AddIcon sx={{ fontSize: 16 }} />
                    </PreviewIconButton>
                </Stack>
            </Stack>
            <Box
                sx={{
                    bgcolor: ocrPalette.grayBg,
                    borderRadius: "8px",
                    p: 1,
                    overflow: "auto",
                    maxHeight: 400,
                }}
            >
                <Document

                    onLoadSuccess={onDocumentLoadSuccess}
                    file={src}
                // options={documentOptions}
                // style={{ width: '100%', height: '100%' }}

                >
                    <Page scale={scale} pageNumber={currentPage} height={400} width={300} />
                </Document>
            </Box>
            {
                numPages > 1 ? (
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        spacing={1.25}
                        sx={{ fontSize: 12, color: ocrPalette.muted }}
                    >
                        <PreviewIconButton
                            ariaLabel="Previous page"
                            disabled={currentPage <= 1}
                            onClick={() => setCurrentPage(currentPage - 1)}
                        >
                            <ChevronLeftIcon sx={{ fontSize: 18 }} />
                        </PreviewIconButton>
                        <Typography sx={{ fontSize: 12, color: ocrPalette.muted }}>
                            Page {currentPage} of {numPages}
                        </Typography>
                        <PreviewIconButton
                            ariaLabel="Next page"
                            disabled={currentPage >= numPages}
                            onClick={() => setCurrentPage(currentPage + 1)}
                        >
                            <ChevronRightIcon sx={{ fontSize: 18 }} />
                        </PreviewIconButton>
                    </Stack>
                ) : <></>
            }
        </Paper >
    )
}

type IconButtonProp = React.ComponentProps<'button'>;

const IconButton = ({ children, style, ...prop }: IconButtonProp) => {
    return (
        <button
            style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                border: "1px solid rgba(15, 23, 42, 0.1)",
                background: "#ffffff",
                color: "#0f172a",
                cursor: "pointer",
                padding: "5px",
                ...style
            }}
            {...prop}
        >
            {children}
        </button >
    )
}

export default PDFViewer